export enum AmendApplicationSuccessType {
  BeingReviewed,
  VendorsInvited,
  SendBackToAgent,
  AmendWhenAwaitingSignatures
}
